module.exports = __webpack_public_path__ + "img/mission_icon.f4ca334c.svg";